import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useI18n } from "@/i18n/I18nProvider";
import Link from "next/link";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css";

import LogosMarquee from "@/components/logos-marquee-slider";

export default function PaymentChannels({  payInstallment,
  channelsLogos,}) {
  const { t, locale } = useI18n();
  const formattedLogos = channelsLogos?.map((logo) => ({
  img: logo.img,
  alt: logo.alt,
}));
const data = payInstallment?.[0];

if (!data) return null;
  return (
    <Box
      component="section"
      aria-label="Payment Channels"
      sx={{
        backgroundColor: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        justifyContent: { xs: "center", lg: "flex-start" },
        alignItems: { xs: "center", lg: "stretch" },
        gap: "55px",
        px: { xs: "30px", md: "50px", lg: "120px" },
        py: { xs: "40px", md: "80px" },
      }}
    >
      {/* Top Row */}
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          justifyContent: { xs: "center", lg: "space-between" },
          alignItems: { xs: "center", lg: "center" },
          width: "100%",
          gap: { xs: 4, lg: 2 },
        }}
      >
        <Box
          data-aos="fade-up"
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: { xs: "center", lg: "space-between" },
            alignItems: { xs: "center", lg: "flex-start" },
            gap: "32px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: { xs: "center", lg: "flex-start" },
            }}
          >
            <Box
            
              component="h2"
              sx={{
                fontSize: { xs: "24px", md: "42px" },
                fontWeight: "700",
                color: "#2D317F",
                textAlign: { xs: "center", lg: "inherit" },
                maxWidth: { xs: "330px", md: "580px" },
                m: 0,
              }}
            >
              {data?.title?.text?.[locale]}
            </Box>

            {/* حجز ارتفاع ثابت للخط لتقليل CLS */}
            <Box
              component="img"
              src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/line.svg"
              alt=""
              aria-hidden="true"
              loading="lazy"
              decoding="async"
              sx={{
                width: { xs: "330px", md: "580px" },
                height: { xs: "6px", md: "7px" },
                display: "block",
                mx: { xs: "auto", md: 0 },
              }}
            />

            {/*
              Must be a <div>, not a <p>. This CMS field contains block-level
              markup (`<p>…</p><p>…</p>`), and <p> cannot legally contain <p>:
              the HTML parser auto-closes the outer <p> at the first inner one,
              so the server-parsed container ends up with innerHTML === "".
              React then compared "" (server) with the real __html (client) and
              abandoned hydration for the whole page.
              A <div> is a valid block container, so the parsed DOM matches what
              React renders. Styling is unchanged — every rule below still
              applies, and the `& p` rule now actually reaches the inner
              paragraphs it was written for.
            */}
            <Box
              component="div"
              sx={{
                fontSize: { xs: "14px", sm: "16px" },
                color: "#404456",
                maxWidth: "630px",
                textAlign: { xs: "center", lg: "inherit" },
                "& p": { margin: 0, lineHeight: "24px" },
                m: 0,
              }}
              dangerouslySetInnerHTML={{
                __html: data?.description?.text?.[locale],
              }}
            />
          </Box>

          <Link
            href="/payment-channels"
            // prefetch={false}
            style={{ textDecoration: "none" }}
          >
            <Button
              sx={{
                backgroundColor: "#F18222",
                width: { xs: "150px", md: "116px" },
                height: "41px",
                color: "#F8F8F8",
                "&:hover": {
                  border: `none`,
                  backgroundColor: "#F18222",
                  color: "#F8F8F8",
                },
              }}
            >
              {t.home_page.payment_channels.button}
            </Button>
          </Link>
        </Box>

        {/* ثبّت ارتفاع تقريبي للإليستريشن لتقليل CLS */}
        <Box
          component="img"
          src={data?.img?.[locale]}
          alt="Payment channels illustration"
          loading="lazy"
          /*
           * This asset is ~1 MB (an un-flattened SVG export) and sits well
           * below the fold. Chrome's lazy-load threshold is generous on slow
           * connections, so it was still being fetched inside the LCP window
           * and competing for bandwidth. fetchPriority="low" keeps it queued
           * behind everything that affects first paint.
           */
          fetchPriority="low"
          decoding="async"
          sx={{
            width: { xs: "250px", sm: "320px", md: "450px" },
            height: { xs: "180px", sm: "230px", md: "320px" },
            objectFit: "contain",
            display: "block",
          }}
        />
      </Box>

      {/* Logos Marquee */}
      <Box
        sx={{
          backgroundColor: "#F8FAFC",
          border: "1px solid #E9EAEA",
          borderRadius: "16px",
          width: "100%",
          cursor: "grab",
          "& .swiper-pagination, & .swiper-pagination-bullet, & .swiper-button-next, & .swiper-button-prev, & .swiper-button-next::after, & .swiper-button-prev::after":
            { display: "none" },
        }}
      >
        <LogosMarquee
       logos={formattedLogos}
        />
      </Box>
    </Box>
  );
}
